// legacy/workaround: BOS never wired real geocoding, the BE requires non-null
// coordinates, and the create/update endpoints bind different field casings —
// both payload shapes are preserved exactly.
const PLACEHOLDER_LATITUDE: string = '17.5896';
const PLACEHOLDER_LONGITUDE: string = '17.556896';

const committedConstructionStages = (formData: any): any[] => {
  const stages: any[] = formData.constructionStages ?? [];

  return stages.filter((stage: any) => !stage.new);
};

const resolvePropertyManagerId = (formData: any): string | null => {
  const nestedManagerId: string | undefined = formData.propertyManager?.id;

  if (nestedManagerId) {
    return nestedManagerId;
  }

  return formData.propertyManagerId ?? null;
};

const resolveStrataManagerId = (formData: any): string | null => {
  if (formData.strataManagerId) {
    return formData.strataManagerId;
  }

  return formData.strataManager?.id ?? null;
};

export const buildPropertyCreateParams = (
  formData: any,
  userId: string,
  imageUrl: string | null
): any => {
  return {
    Name: formData.name,
    AddressLine1: formData.addressLine1,
    AddressLine2: '',
    City: formData.city,
    Province: formData.province,
    PostalCode: formData.postalCode,
    Latitude: PLACEHOLDER_LATITUDE,
    Longitude: PLACEHOLDER_LONGITUDE,
    Image: imageUrl,
    UserId: userId,
    PropertyManagerId: formData.propertyManagerId,
    StrataManagerId: formData.strataManagerId,
    ConstructionStages: committedConstructionStages(formData),
    modulePermissions: formData.modulePermissions || [],
  };
};

export const buildPropertyUpdateParams = (
  formData: any,
  userId: string,
  imageUrl: string | null
): any => {
  const resolvedImage: string | null = imageUrl ?? formData.image;

  return {
    id: formData.propertyId,
    propertyId: formData.propertyId,
    name: formData.name,
    addressLine1: formData.addressLine1,
    addressLine2: '',
    city: formData.city,
    province: formData.province,
    postalCode: formData.postalCode,
    latitude: PLACEHOLDER_LATITUDE,
    longitude: PLACEHOLDER_LONGITUDE,
    image: resolvedImage,
    UserId: userId,
    PropertyManagerId: resolvePropertyManagerId(formData),
    StrataManagerId: resolveStrataManagerId(formData),
    ConstructionStages: committedConstructionStages(formData),
    modulePermissions: formData.modulePermissions || [],
  };
};